import React from 'react';
import '../../styles/pages.css';

export default function Billing() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Billing</h1>
        <p>Manage your billing and payments</p>
      </div>
      <div className="page-section">
        <div className="stat-card" style={{ marginBottom: '2rem' }}>
          <div className="stat-content">
            <h3>Account Balance</h3>
            <p className="stat-number">$1,240.50</p>
          </div>
        </div>
        <button className="btn-primary">Add Credits</button>
      </div>
    </div>
  );
}
